export const causes = {
    lateness: 'Опоздание',
}
